import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import { useContextValue } from '../../../context/context';
import { QualificationIcon } from "../../../assets/cardIcons";
import './style.css';

//? Temporary data
const qualificationsData = ["Keine Angabe", "Staatlich geprüft", "mit Eignung", "Xxxx xxx", "Xxxx xxx"];

const QualificationPopUp = ({ onClose }) => {
	const { setQualification, filledCards, setFilledCards } = useContextValue();

	const handleQualification = (qualification) => {
		setQualification(qualification);

		const newCard = { content: qualification, isSelected: true, title: "Qualifikation", backgroundColor: "#925B92", icon: QualificationIcon };
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	}

	return (
		<div className="qualification-popup">
			<div className="qualification-options">
				{
					qualificationsData.map((qualification, index) => <p key={index} onClick={() => handleQualification(qualification)} className="qualification-option">{qualification}</p>)
				}
			</div>
			<ClosePopUpButton />
		</div>
	)
}

export default QualificationPopUp
